import React from "react";

import { Field, Label, Description, ErrorMessage } from "V2.0/common/fieldset";
import { Textarea } from "V2.0/common/textarea";
import { Badge } from "V2.0/common/badge";

import { DecideCopy } from "../models/sections";
import { listPromptVariables } from "../models/promptVariables";

type Props = {
  copy: DecideCopy;
  apiGatePrompt: string;
  apiTriggerPrompt: string;
  errors: Record<string, string>;
  onChange: (patch: { apiGatePrompt?: string; apiTriggerPrompt?: string }) => void;
};

export function HowWeDecide({ copy, apiGatePrompt, apiTriggerPrompt, errors, onChange }: Props) {
  const variables = listPromptVariables([copy.showsQuickCheck ? apiGatePrompt : "", apiTriggerPrompt]);

  return (
    <>
      {copy.showsQuickCheck && (
        <Field>
          <div className="flex items-center gap-2">
            <Label>Quick check</Label>
            <Badge color="zinc">Optional</Badge>
          </div>
          <Description>
            Read on every turn of the conversation. Keep it short: what has to be true before this API is worth a closer look.
          </Description>
          <Textarea
            name="apiGatePrompt"
            value={apiGatePrompt}
            onChange={(event) => onChange({ apiGatePrompt: event.target.value })}
            height="110px"
            className="text-sm"
          />
          {errors.apiGatePrompt && <ErrorMessage>{errors.apiGatePrompt}</ErrorMessage>}
        </Field>
      )}

      <Field>
        <Label>{copy.detailedLabel}</Label>
        <Description>{copy.detailedDescription}</Description>
        <Textarea
          name="apiTriggerPrompt"
          value={apiTriggerPrompt}
          onChange={(event) => onChange({ apiTriggerPrompt: event.target.value })}
          height="260px"
          className="text-sm"
        />
        {errors.apiTriggerPrompt && <ErrorMessage>{errors.apiTriggerPrompt}</ErrorMessage>}
      </Field>

      {variables.length > 0 && (
        <div className="flex flex-col gap-2">
          <p className="text-xs font-medium uppercase tracking-wide text-zinc-500">Call variables used</p>
          <div className="flex flex-wrap gap-1.5">
            {variables.map((name) => (
              <Badge key={name} color="blue">{`{${name}}`}</Badge>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
